module.exports = __webpack_public_path__ + "static/media/26UNRWA4.35ae4b7b.jpg";